// extracted by mini-css-extract-plugin
var _1 = "TmE5fCmxn9aaDGa37nc_";
export { _1 as "root" }
